<template>
  <BModal
    :model-value="modal"
    scrollable
    centered
    no-close-on-backdrop
    title="Reservation Form"
    @update:modelValue="updateModal"
  >
    <template #header>
      <div
        class="d-flex align-items-center justify-content-between modal-title w-100"
      >
        <h5 class="mb-0 title">Reservation Form</h5>
        <!-- <div class="d-flex gap-2 align-items-center">
          <span class="date">17/02/2025 16:00:00</span>
          <span
            class="bg-success rounded-circle bar-status"
            style="width: 10px; height: 10px"
          ></span>
          <span class="info-status">online: <span>Ruth</span></span>
        </div> -->
      </div>
      <BButton variant="link" class="close" @click="closeModal">
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>
    <BTabs content-class="mt-3" align="center" justified>
      <BTab title="Reservation" active>
        <BForm>
          <div class="form-group position-relative">
            <BFormInput
              v-model="searchQuery"
              @focus="isTyped = true"
              @blur="handleBlur"
              placeholder="Search guest name"
              autocomplete="off"
            >
            </BFormInput>

            <BListGroup
              v-if="
                searchQuery.length > 0 &&
                filteredGuestItems.length > 0 &&
                isTyped
              "
              class="position-absolute w-100 border rounded-lg"
              style="z-index: 10; cursor: pointer"
            >
              <BListGroupItem
                v-for="(guest, index) in filteredGuestItems"
                :key="index"
                @mousedown.prevent="selectGuest(guest)"
                :value="guest.uuid"
                v-model="reservationForm.guest_uuid"
                class="p-2 border-0"
                >{{ guest.fullname }}</BListGroupItem
              >
            </BListGroup>
            <span
              v-if="searchQuery.length && filteredGuestItems === 0"
              class="text-muted mt-2"
            >
              Guest not found <router-link to="/guest">Add guest</router-link>
            </span>
          </div>
          <BRow>
            <BCol>
              <div class="form-group">
                <label for="">Check-in Date</label>
                <BFormInput type="date" v-model="reservationForm.start">
                </BFormInput>
              </div>
            </BCol>
            <BCol>
              <div class="form-group">
                <label for="">Check-out Date</label>
                <BFormInput type="date" v-model="reservationForm.end">
                </BFormInput>
              </div>
            </BCol>
          </BRow>
          <div class="form-group">
            <BFormSelect
              v-model="selectedRoomCategory"
              :options="roomCategories"
              text-field="name"
              value-field="name"
              class=""
              :disabled="!reservationForm.start || !reservationForm.end"
            >
              <template #first>
                <BFormSelectOption :value="null" disabled
                  >Select Type Room</BFormSelectOption
                >
              </template>
            </BFormSelect>
          </div>
          <div v-if="selectedRoomCategory" class="form-group">
            <BFormSelect
              v-model="reservationForm.room_uuid"
              :options="filteredRoomItems"
              text-field="code"
              value-field="uuid"
              @change="handleSelectedRoom($event.target.value)"
              class=""
              :disabled="!reservationForm.start && !reservationForm.end"
            >
              <template #first>
                <BFormSelectOption :value="null" disabled>
                  Select Room Number
                </BFormSelectOption>
              </template>
            </BFormSelect>
          </div>

          <div class="form-group">
            <BFormSelect
              v-model="selectedSourceType"
              :options="sourceTypes"
              text-field="name"
              value-field="type"
              class=""
              @change="
                selectedSourceType === 'walk_in' ||
                selectedSourceType === 'direct_booking'
                  ? (reservationForm.source_uuid = sources.find(
                      (s) => s.type == selectedSourceType
                    ).uuid)
                  : ''
              "
            >
              <template #first>
                <BFormSelectOption :value="null" disabled>
                  Select Source
                </BFormSelectOption>
              </template>
            </BFormSelect>
          </div>
          <div
            class="form-group"
            v-if="
              selectedSourceType &&
              selectedSourceType != 'walk_in' &&
              selectedSourceType != 'direct_booking'
            "
          >
            <BFormSelect
              v-model="reservationForm.source_uuid"
              :options="filteredSourceItems"
              text-field="name"
              value-field="uuid"
              class=""
            >
              <template #first>
                <BFormSelectOption :value="null" disabled>
                  {{
                    selectedSourceType === "booking_online"
                      ? "Select Platform"
                      : "Select Agent"
                  }}
                </BFormSelectOption>
              </template>
            </BFormSelect>
          </div>
          <div
            class="form-group"
            v-if="selectedSourceType === 'booking_online'"
          >
            <BFormInput
              type="text"
              v-model="reservationForm.booking_number"
              placeholder="Booking Confirmation Number (optional)"
            ></BFormInput>
          </div>
        </BForm>
      </BTab>
      <!--  tab extracharge -->
      <BTab title="Extracharge">
        <BForm>
          <BRow v-for="(ext, index) in extraChargeItems" :key="index">
            <BCol md="5">
              <div class="form-group">
                <BFormSelect
                  v-model="ext.selectedExtraChargeCategory"
                  :options="extraChargeCategories"
                  text-field="name"
                  value-field="uuid"
                  @change="
                    handleExtraChargeCategory($event.target.value, index)
                  "
                  class=""
                >
                  <template #first>
                    <BFormSelectOption :value="null" disabled>
                      Select Category
                    </BFormSelectOption>
                  </template>
                </BFormSelect>
              </div>
            </BCol>
            <BCol md="3">
              <div class="form-group">
                <BFormSelect
                  v-model="ext.selectedExtraChargeUuid"
                  :options="ext.extracharges"
                  text-field="name"
                  value-field="uuid"
                  @change="handleExtraCharge($event.target.value, index)"
                  class=""
                >
                  <template #first>
                    <BFormSelectOption :value="null" disabled>
                      Select Item
                    </BFormSelectOption>
                  </template>
                </BFormSelect>
              </div>
            </BCol>
            <BCol md="4">
              <div class="form-group">
                <BInputGroup>
                  <BButton
                    variant="light"
                    class="border"
                    @click="decreaseQuantity(index)"
                    ><i class="fas fa-minus"></i
                  ></BButton>
                  <BFormInput
                    type="number"
                    v-model="ext.quantity"
                    min="0"
                    class="text-center"
                  ></BFormInput>
                  <BButton
                    variant="light"
                    class="border"
                    @click="increaseQuantity(index)"
                    ><i class="fas fa-plus"></i
                  ></BButton>
                </BInputGroup>
              </div>
            </BCol>
          </BRow>
          <BButton variant="danger" @click="deleteItemExtracharge" class="mr-2"
            ><i class="fas fa-minus"></i
          ></BButton>
          <BButton variant="success" @click="addItemExtraCharge"
            ><i class="fas fa-plus"></i
          ></BButton>
          <div class="d-flex justify-content-end align-items-center">
            <p class="m-0">
              Total Price : <strong>Rp.{{ totalExtraChargePrice }}</strong>
            </p>
          </div>
        </BForm>
      </BTab>
      <BTab title="Payment">
        <div class="form-group">
          <BFormSelect v-model="reservationForm.payment_method_uuid" class="">
            <template #first>
              <BFormSelectOption :value="null" disabled>
                Select payment method
              </BFormSelectOption>
            </template>
            <BFormSelectOption
              v-for="method in paymentMethods"
              :key="method.uuid"
              :value="method.uuid"
            >
              {{ method.name }} {{ method.number }}
            </BFormSelectOption>
          </BFormSelect>
        </div>
        <div class="form-group">
          <BFormRadioGroup
            v-model="reservationForm.payment_status"
            :options="paymentStatus"
            text-field="text"
            value-field="text"
            @change="handleSelectedPaymentStatus($event.target.value)"
          />
        </div>
        <div class="form-group" v-if="reservationForm.payment_status == 'DP'">
          <label for="">Total Bill</label>
          <BFormInput
            type="number"
            v-model="reservationForm.totalPriceBeforeDiscount"
            :value="totalPriceBeforeDiscount"
            placeholder="0"
            disabled
          >
          </BFormInput>
        </div>

        <BRow v-show="reservationForm.payment_status == 'DP'">
          <BCol>
            <div class="form-group">
              <label for="">Discount for Room (optional)</label>
              <BFormInput
                type="number"
                v-model="reservationForm.discount"
                placeholder="% / nominal "
              >
              </BFormInput>
            </div>
          </BCol>
          <BCol>
            <div class="form-group">
              <label for="">Discount Value</label>
              <BFormInput
                type="number"
                :value="discountAmount"
                placeholder="0"
                disabled
              >
              </BFormInput>
            </div>
          </BCol>
        </BRow>

        <div class="form-group" v-show="reservationForm.payment_status == 'DP'">
          <label for="">Grand Total</label>
          <BFormInput
            type="number"
            v-model="reservationForm.grand_total"
            :value="grandTotal"
            placeholder="0"
            disabled
          >
          </BFormInput>
        </div>

        <div class="form-group" v-show="reservationForm.payment_status == 'DP'">
          <label for="">Input Pre Payment</label>
          <BFormInput
            type="number"
            v-model="reservationForm.pre_payment"
            placeholder="Masukkan nominal"
          >
          </BFormInput>
        </div>

        <div
          class="form-group"
          v-show="reservationForm.payment_status == 'Full Payment'"
        >
          <label for="">Total Bill</label>
          <BFormInput
            type="number"
            v-model="reservationForm.totalPriceBeforeDiscount"
            :value="totalPriceBeforeDiscount"
            placeholder="0"
            disabled
          >
          </BFormInput>
        </div>
        <BRow v-show="reservationForm.payment_status == 'Full Payment'">
          <BCol>
            <div class="form-group">
              <label for="">Discount for Room(optional)</label>
              <BFormInput
                type="number"
                v-model="reservationForm.discount"
                placeholder="% / nominal "
              >
              </BFormInput>
            </div>
          </BCol>
          <BCol>
            <div class="form-group">
              <label for="">Discount Value</label>
              <BFormInput
                type="number"
                :value="discountAmount"
                placeholder="0"
                disabled
              >
              </BFormInput>
            </div>
          </BCol>
        </BRow>
        <div
          class="form-group"
          v-show="reservationForm.payment_status == 'Full Payment'"
        >
          <label for="">Grand Total</label>
          <BFormInput
            type="number"
            v-model="reservationForm.grand_total"
            :value="grandTotal"
            placeholder="0"
            disabled
          >
          </BFormInput>
        </div>
        <div class="form-group">
          <label for="">Payment Date</label>
          <BFormInput type="date" v-model="reservationForm.payment_date">
          </BFormInput>
        </div>

        <div class="form-group">
          <BFormTextarea
            v-model="reservationForm.description"
            placeholder="Remarks(optional)"
            rows="3"
          />
        </div>
      </BTab>
    </BTabs>
    <template #footer>
      <div class="d-flex justify-content-end">
        <BButton
          variant="primary"
          @click="handleAction"
          class="mr-2"
          :disabled="isLoading"
        >
          {{
            isLoading
              ? "Loading..."
              : reservationData && reservationData.uuid
              ? "Update"
              : "Save"
          }}
        </BButton>
        <BButton variant="danger" @click="closeModal">Cancel</BButton>
        <!-- <BButton variant="info" @click="testEc">tes EC</BButton> -->
      </div>
    </template>
  </BModal>

  <BModal
    :model-value="modalReschedule"
    scrollable
    centered
    no-close-on-backdrop
    title="Reservation Reschedule"
    @update:modelValue="updateModal"
  >
    <template #header>
      <div
        class="d-flex align-items-center justify-content-between modal-title w-100"
      >
        <h5 class="mb-0 title">Reschedule Form</h5>
        <!-- <div class="d-flex gap-2 align-items-center">
          <span class="date">17/02/2025 16:00:00</span>
          <span
            class="bg-success rounded-circle bar-status"
            style="width: 10px; height: 10px"
          ></span>
          <span class="info-status">online: <span>Ruth</span></span>
        </div> -->
      </div>
      <BButton variant="link" class="close" @click="closeModal">
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>
    <!-- <BTabs content-class="mt-3" align="center" justified> -->

    <BForm>
      <div class="form-group position-relative">
        <BFormInput
          v-model="searchQuery"
          @focus="isTyped = true"
          @blur="handleBlur"
          placeholder="Search guest name"
          autocomplete="off"
        >
        </BFormInput>

        <BListGroup
          v-if="
            searchQuery.length > 0 && filteredGuestItems.length > 0 && isTyped
          "
          class="position-absolute w-100 border rounded-lg"
          style="z-index: 10; cursor: pointer"
        >
          <BListGroupItem
            v-for="(guest, index) in filteredGuestItems"
            :key="index"
            @mousedown.prevent="selectGuest(guest)"
            :value="guest.uuid"
            v-model="reservationForm.guest_uuid"
            class="p-2 border-0"
            >{{ guest.fullname }}</BListGroupItem
          >
        </BListGroup>
        <span
          v-if="searchQuery.length && filteredGuestItems === 0"
          class="text-muted mt-2"
        >
          Guest not found <router-link to="/guest">Add guest</router-link>
        </span>
      </div>
      <BRow>
        <BCol>
          <div class="form-group">
            <label for="">Check-in Date</label>
            <BFormInput type="date" v-model="reservationForm.start">
            </BFormInput>
          </div>
        </BCol>
        <BCol>
          <div class="form-group">
            <label for="">Check-out Date</label>
            <BFormInput type="date" v-model="reservationForm.end"> </BFormInput>
          </div>
        </BCol>
      </BRow>
      <div class="form-group">
        <BFormSelect
          v-model="selectedRoomCategory"
          :options="roomCategories"
          text-field="name"
          value-field="name"
          class=""
          :disabled="!reservationForm.start || !reservationForm.end"
        >
          <template #first>
            <BFormSelectOption :value="null" disabled
              >Select Type Room</BFormSelectOption
            >
          </template>
        </BFormSelect>
      </div>
      <div v-if="selectedRoomCategory" class="form-group">
        <BFormSelect
          v-model="reservationForm.room_uuid"
          :options="filteredRoomItems"
          text-field="code"
          value-field="uuid"
          @change="handleSelectedRoom($event.target.value)"
          class=""
          :disabled="!reservationForm.start || !reservationForm.end"
        >
          <template #first>
            <BFormSelectOption :value="null" disabled>
              Select Room Number
            </BFormSelectOption>
          </template>
        </BFormSelect>
      </div>
    </BForm>

    <!-- </BTabs> -->
    <template #footer>
      <div class="d-flex justify-content-end">
        <BButton
          variant="primary"
          @click="handleAction"
          class="mr-2"
          :disabled="isLoading"
        >
          {{
            isLoading
              ? "Loading..."
              : reservationData && reservationData.uuid
              ? "Update"
              : "Save"
          }}
        </BButton>
        <BButton variant="danger" @click="closeModal">Cancel</BButton>
        <!-- <BButton variant="info" @click="testEc">tes EC</BButton> -->
      </div>
    </template>
  </BModal>

  <ToastResponse
    v-model="modalResponse.toast"
    :text="modalResponse.text"
    :success="modalResponse.success"
  ></ToastResponse>
</template>
<script>
import { ref, computed, watch, nextTick, onMounted, inject } from "vue";
import ToastResponse from "@/components/ToastResponse.vue";
import {
  BModal,
  BFormInput,
  BFormSelect,
  BFormSelectOption,
  BForm,
  BRow,
  BCol,
  BTabs,
  BTab,
  BFormRadioGroup,
  BInputGroup,
  BListGroup,
  BListGroupItem,
  BButton,
  BFormTextarea,
} from "bootstrap-vue-next";
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import { formatIDR } from "@/utils/currency";
import { useRoomPrice } from "@/composable/useRoomPrice";

export default {
  name: "ReservationForm",
  components: {
    BModal,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    BButton,
    BForm,
    BRow,
    BCol,
    BTabs,
    BTab,
    BFormTextarea,
    BInputGroup,
    BListGroup,
    BListGroupItem,
    BFormRadioGroup,
    ToastResponse,
  },
  props: {
    modal: Boolean,
    modalReschedule: Boolean,
    reservationData: Object,
  },
  emits: [
    "update:modal",
    "update:modalReschedule",
    "update:reservationData",
    "addOrUpdate",
  ],

  setup(props, { emit }) {
    const repositories = inject("repositories");
    const guestRepository = repositories ? repositories.guests : null;
    const extraChargeCategoryRepository = repositories
      ? repositories.extraChargeCategory
      : null;
    const extraChargeRepository = repositories
      ? repositories.extraCharges
      : null;
    const paymentMethodRepository = repositories
      ? repositories.paymentMethod
      : null;
    const roomCategoryRepository = repositories
      ? repositories.roomCategory
      : null;
    const roomRepository = repositories ? repositories.rooms : null;
    const reservationRepository = repositories
      ? repositories.reservations
      : null;
    const sourceRepository = repositories ? repositories.source : null;

    const isLoading = ref(false);

    const paymentStatus = ref([
      { text: "DP", value: "DP" },
      { text: "Full Payment", value: "Full Payment" },
    ]);
    const selectedPaymentMethod = ref(null);

    const roomCategories = ref([]);
    const selectedRoomCategory = ref(null);
    const rooms = ref([]);
    const selectedRoom = ref(null);
    const guests = ref([]);
    const filteredGuestItems = ref([]);
    const sources = ref([]);
    const selectedSourceType = ref(null);
    const selectedSourceItem = ref(null);
    const extraChargeItems = ref([
      {
        selectedExtraChargeUuid: null,
        selectedExtraChargeCategory: null,
        extracharges: [],
        quantity: 0,
        price: 0,
      },
    ]);
    const extracharges = ref([]);
    const extraChargeCategories = ref([]);
    const selectedExtraChargeCategory = ref(null);
    const selectedExtraChargeItem = ref(null);
    const paymentMethods = ref([]);
    const searchQuery = ref("");
    const isTyped = ref(false);
    const extracharge = ref({});
    const roomItem = ref({
      price: 0,
    });

    const reservationForm = ref({
      uuid: null,
      extra_charges: [],
      payment_method_uuid: null,
      room_uuid: null,
      source_uuid: null,
      guest_uuid: null,
      start: "",
      end: "",
      days: 0,
      discount: 0,
      discount_amount: null,
      grand_total: null,
      description: "",
      payment_status: "DP",
      payment_date: null,
      pre_payment: null,
      room_category: "",
      source_name: "",
      guest_fullname: "",
      booking_number: "",
      room_price: 0,
      is_high_season: false,
    });

    const modalResponse = ref({
      toast: false,
      text: "",
      success: false,
    });

    let echo = null;
    const initEcho = () => {
      window.Pusher = Pusher;
      echo = new Echo({
        broadcaster: "reverb",
        key: import.meta.env.VITE_REVERB_APP_KEY,
        wsHost: import.meta.env.VITE_REVERB_HOST,
        wsPort: import.meta.env.VITE_REVERB_PORT,
        forceTLS: false,
        disableStats: true,
      });

      echo
        .channel("reservations")
        .listen("ReservationCreated", (event) => {
          reservationForm.value.push(event.reservation);
        })
        .listen("ReservationUpdated", (event) => {
          const index = reservationForm.value.findIndex(
            (r) => r.uuid === event.reservation.uuid
          );
          if (index !== -1) {
            reservationForm.value[index] = event.reservation;
          }
        })
        .listen("ReservationDeleted", (event) => {
          reservationForm.value = reservationForm.value.filter(
            (r) => r.uuid !== event.reservation.uuid
          );
        });
    };

    const getListGuest = async (params) => {
      await guestRepository
        .getAll(params)
        .then((res) => {
          guests.value = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const getListRoomType = (params) => {
      roomCategoryRepository
        .getAll(params)
        .then((res) => {
          roomCategories.value = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const getListRoom = (category) => {
      const params = {
        category: category,
        start: reservationForm.value.start,
        end: reservationForm.value.end,
      };

      if (reservationForm.value.uuid) {
        params.reservation_uuid = reservationForm.value.uuid;
      }

      roomRepository
        .getAll(params)
        .then((res) => {
          rooms.value = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const getListSource = (params) => {
      sourceRepository
        .getAll(params)
        .then((res) => {
          sources.value = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const getListExtraChargeCategory = (params) => {
      extraChargeCategoryRepository
        .getAll(params)
        .then((res) => {
          extraChargeCategories.value = [...res.data.data];
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const getListExtraCharge = (selectedExtraChargeCategory, index) => {
      extraChargeRepository
        .getAll({ extra_charge_category_uuid: selectedExtraChargeCategory })
        .then((res) => {
          if (selectedExtraChargeCategory.length) {
            extraChargeItems.value[index].extracharges = [...res.data.data];
          }
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const getListPaymentMethod = () => {
      paymentMethodRepository
        .getAll()
        .then((res) => {
          paymentMethods.value = [
            ...res.data.data.filter((i) => (i.status === "active" ? i : null)),
          ];
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const create = () => {
      isLoading.value = true;
      reservationForm.value = {
        ...reservationForm.value,
        grand_total: grandTotal.value,
        discount_amount: discountAmount.value,
        days: calculateDays.value,
        status: "booked",
        discount: reservationForm.value.discount || 0,
        extra_charges: extraChargeItems.value
          .filter((item) => item.selectedExtraChargeUuid !== null)
          .map((item) => ({
            uuid: item.selectedExtraChargeUuid,
            quantity: item.quantity,
            price: item.extracharges[0]?.price,
          })),
      };

      reservationRepository
        .create(reservationForm.value)
        .then(() => {
          updateModal(false);
          Object.assign(reservationForm.value, {});
          searchQuery.value = "";
          selectedRoomCategory.value = null;
          selectedSourceType.value = null;
          Object.assign(modalResponse.value, {
            success: true,
            text: "Reservation created successfully",
            toast: true,
          });
          emit("addOrUpdate");
        })
        .catch((err) => {
          Object.assign(modalResponse.value, {
            success: false,
            text: err.response.data.message,
            toast: true,
          });
        })
        .finally(() => {
          isLoading.value = false;
        });
    };

    const update = () => {
      isLoading.value = true;
      reservationForm.value = {
        ...reservationForm.value,
        grand_total: grandTotal.value,
        discount_amount: discountAmount.value,
        days: calculateDays.value,
        discount: reservationForm.value.discount || 0,
        extra_charges: extraChargeItems.value
          .filter((item) => item.selectedExtraChargeUuid !== null)
          .map((item) => ({
            uuid: item.selectedExtraChargeUuid,
            quantity: item.quantity,
            price: item.extracharges[0]?.price,
          })),
      };

      console.log("nilai diskon", discountAmount.value);

      reservationRepository
        .update(reservationForm.value.uuid, reservationForm.value)
        .then(() => {
          updateModal(false);
          Object.assign(reservationForm.value, {});
          searchQuery.value = "";
          selectedRoomCategory.value = null;
          selectedSourceType.value = null;
          Object.assign(modalResponse.value, {
            success: true,
            text: "Reservation updated successfully",
            toast: true,
          });
          emit("addOrUpdate");
        })
        .catch((err) => {
          Object.assign(modalResponse.value, {
            success: false,
            text: err.response.data.message,
            toast: true,
          });
        })
        .finally(() => {
          isLoading.value = false;
        });
    };

    const addItemExtraCharge = () => {
      extraChargeItems.value.push({
        extra_charge_uuid: null,
        selectedExtraChargeCategory: null,
        extracharges: [],
        quantity: 0,
        price: 0,
      });
    };
    const deleteItemExtracharge = () => {
      if (extraChargeItems.value.length > 1) {
        extraChargeItems.value.pop();
      }
    };
    const increaseQuantity = (index) => {
      extraChargeItems.value[index].quantity++;
    };
    const decreaseQuantity = (index) => {
      if (extraChargeItems.value[index].quantity > 0) {
        extraChargeItems.value[index].quantity--;
      }
    };
    const handleSelectedPaymentStatus = (event) => {
      reservationForm.value.payment_status = event;
    };
    const handleBlur = () => {
      setTimeout(() => {
        isTyped.value = false;
      }, 200);
    };
    const handleSelectedRoom = (event) => {
      const selectedRoom = rooms.value.find((room) => room.uuid === event);
      console.log(selectedRoom);
      // console.log(selectedRoom)
      // if (selectedRoom) {
      //   roomItem.value.price = selectedRoom.price;
      // }
    };
    const closeModal = () => {
      updateModal(false);
      searchQuery.value = "";
      selectedRoomCategory.value = null;
      selectedSourceType.value = null;
    };
    const updateModal = (value) => {
      reservationForm.value = {};
      emit("update:modal", value); // Sync modal state with parent
      emit("update:modalReschedule", value);
    };
    const selectGuest = (guest) => {
      reservationForm.value.guest_uuid = guest.uuid;
      searchQuery.value = guest.fullname;
      isTyped.value = true;
      nextTick(() => {
        filteredGuestItems.value = [];
      });
    };

    const totalExtraChargePrice = computed(() => {
      return extraChargeItems.value.reduce((sum, ext) => {
        const selectedItem = ext.extracharges.find(
          (item) => item.value === ext.selectedItem
        );
        return sum + (selectedItem ? selectedItem.price * ext.quantity : 0);
      }, 0);
    });

    // const isHighSeason = computed(() => {
    //   const startDate = new Date(reservationForm.value.start);
    //   const endDate = new Date(reservationForm.value.end);

    //   return startDate.getMonth() === 5 || endDate.getMonth() === 5; // bulan Juni (0-indexed)
    // });

    // const roomPrice = computed(() => {
    //   const selectedRoom = rooms.value.find(
    //     (room) => room.uuid === reservationForm.value.room_uuid
    //   );

    //   if (!selectedRoom) return 0;

    //   const priceType = isHighSeason.value
    //     ? "high_season_price"
    //     : "low_season_price";
    //   return selectedRoom.room_category[priceType] || 0;
    // });

    //Telah dibuat jadi Function Composable
    const { isHighSeason, roomPrice } = useRoomPrice(reservationForm, rooms);

    const calculateDays = computed(() => {
      if (reservationForm.value.start && reservationForm.value.end) {
        const startDate = new Date(reservationForm.value.start);
        const endDate = new Date(reservationForm.value.end);

        const timeDifference = endDate.getTime() - startDate.getTime();

        const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));
        return daysDifference;
      }
      return 0;
    });

    const totalPriceBeforeDiscount = computed(() => {
      return (
        //roomPrice.value * calculateDays.value + totalExtraChargePrice.value
        roomPrice.value * calculateDays.value
      );
    });

    const discountAmount = computed(() => {
      if (reservationForm.value.discount) {
        if (reservationForm.value.discount.toString().length <= 3) {
          return (
            totalPriceBeforeDiscount.value *
            (parseFloat(reservationForm.value.discount) / 100)
          );
        } else {
          return parseFloat(reservationForm.value.discount);
        }
      }
      return 0;
    });

    const grandTotal = computed(() => {
      return totalPriceBeforeDiscount.value + totalExtraChargePrice.value - discountAmount.value;
    });

    const handleExtraChargeCategory = (category, index) => {
      extraChargeItems.value[index].extra_charge_uuid = null; // Reset item when category changes
      getListExtraCharge(category, index); // Fetch charges based on selected category
    };
    const handleExtraCharge = (uuid, index) => {
      extraChargeItems.value[index].selectedExtraChargeUuid = uuid;

      if (!Array.isArray(reservationForm.value.extra_charges)) {
        reservationForm.value.extra_charges = [];
      }
      // Ensure we only add unique UUIDs
      // if (!reservationForm.value.extra_charges.includes(uuid)) {
      //   reservationForm.value.extra_charges.push(uuid);
      // }
    };

    const sourceTypes = computed(() => {
      const sourceFormat = {
        booking_online: "Booking Online",
        walk_in: "Walk In",
        direct_booking: "Direct Booking",
        agent: "Agent",
      };
      const types = new Set();
      return sources.value
        .filter((item) => {
          if (!types.has(item.type)) {
            types.add(item.type);
            return true;
          }
          return false;
        })
        .map((item) => ({
          type: item.type,
          name:
            sourceFormat[item.type] ||
            item.type.charAt(0).toUpperCase() + item.type.slice(1), // Capitalize for display
        }));
    });

    const filteredSourceItems = computed(() => {
      if (selectedSourceType.value === "booking_online") {
        return sources.value.filter((item) => item.type === "booking_online");
      } else if (selectedSourceType.value === "agent") {
        return sources.value.filter((item) => item.type === "agent");
      }

      return []; // Return an empty array if no valid type is selected
    });

    const handleAction = () => {
      props.reservationData.uuid ? update() : create();
    };

    watch(isHighSeason, (value) => {
      reservationForm.value.is_high_season = value;
    });

    watch(roomPrice, (value) => {
      reservationForm.value.room_price = value;
    });

    watch(searchQuery, (newQuery) => {
      if (!newQuery && isTyped.value) {
        filteredGuestItems.value = [];
      } else {
        filteredGuestItems.value = guests.value.filter((guest) => {
          return guest.fullname.toLowerCase().includes(newQuery.toLowerCase());
        });
      }
    });

    const filteredRoomItems = computed(() => {
      return rooms.value.filter(
        (room) => room.room_category.name === selectedRoomCategory.value
      );
    });

    watch(selectedRoomCategory, (newCategory) => {
      if (newCategory) {
        getListRoom(newCategory);
      }
    });

    watch(
      [() => reservationForm.value.start, () => reservationForm.value.end],
      ([newStart, newEnd]) => {
        if (newStart && newEnd) {
          getListRoom(selectedRoomCategory.value);
        }
      }
    );

    watch(
      () => reservationForm.value.payment_status,
      (newStatus) => {
        reservationForm.value.discount_amount = discountAmount.value;
        reservationForm.value.totalPriceBeforeDiscount =
          totalPriceBeforeDiscount.value;
        reservationForm.value.grand_total = grandTotal.value;

        if (newStatus === "DP") {
          reservationForm.value.pre_payment =
            props.reservationData.pre_payment || 0;
        }
        if (newStatus === "Full Payment") {
          reservationForm.value.pre_payment = 0;
        }
      }
    );

    watch(
      () => props.reservationData,
      (newData) => {
        if (
          newData &&
          (newData.guest ||
            newData.room ||
            newData.source ||
            newData.payment_method ||
            (newData.extracharge && Array.isArray(newData.extracharge)))
        ) {
          searchQuery.value = newData.guest.fullname;
          reservationForm.value.uuid = newData.uuid;
          reservationForm.value.guest_uuid = newData.guest.uuid;
          selectedRoomCategory.value = newData.room.room_category.name;
          reservationForm.value.room_uuid = newData.room.uuid;
          selectedSourceType.value = newData.source.type;
          reservationForm.value.payment_method_uuid =
            newData.payment_method.uuid;
          reservationForm.value.source_uuid = newData.source.uuid;
          reservationForm.value.payment_status = newData.payment_status;
          reservationForm.value.payment_date = newData.payment_date;
          reservationForm.value.pre_payment = newData.pre_payment;
          reservationForm.value.discount = parseInt(newData.discount);
          reservationForm.value.start = newData.start;
          reservationForm.value.end = newData.end;
          reservationForm.value.number = newData.number;
          reservationForm.value.description = newData.description;
          reservationForm.value.status = newData.status;
          reservationForm.value.booking_number = newData.booking_number;
          extraChargeItems.value = [];

          // Map extracharges to the required format
          newData.extracharge.forEach((ext) => {
            extraChargeItems.value.push({
              selectedExtraChargeCategory:
                ext.extra_charge.extracharge_category.uuid,
              selectedExtraChargeUuid: ext.extra_charge.uuid,
              extracharges: [
                {
                  name: ext.extra_charge.name,
                  price: ext.extra_charge.price,
                  quantity: ext.quantity,
                  uuid: ext.extra_charge.uuid,
                },
              ],
              quantity: ext.quantity,
            });
          });
        } else {
          // Reset to default if no extracharges
          extraChargeItems.value = [
            {
              selectedExtraChargeUuid: null,
              selectedExtraChargeCategory: null,
              extracharges: [],
              quantity: 0,
            },
          ];
        }
      },
      { immediate: true } // This ensures it runs immediately on initial load
    );
    onMounted(() => {
      getListGuest();
      getListRoomType();
      getListSource();
      getListExtraChargeCategory();
      getListPaymentMethod();
    });

    return {
      isLoading,
      initEcho,
      create,
      updateModal,
      closeModal,
      handleAction,
      handleSelectedPaymentStatus,
      handleExtraChargeCategory,
      handleExtraCharge,
      handleSelectedRoom,
      handleBlur,
      addItemExtraCharge,
      deleteItemExtracharge,
      increaseQuantity,
      decreaseQuantity,
      selectGuest,
      getListGuest,
      getListRoomType,
      getListRoom,
      getListSource,
      getListExtraChargeCategory,
      getListExtraCharge,
      getListPaymentMethod,
      roomCategories,
      rooms,
      roomItem,
      selectedRoomCategory,
      selectedRoom,
      selectedPaymentMethod,
      selectedSourceType,
      selectedSourceItem,
      sources,
      selectedExtraChargeCategory,
      selectedExtraChargeItem,
      extraChargeItems,
      extracharges,
      extraChargeCategories,
      extracharge,
      reservationForm,
      paymentMethods,
      paymentStatus,
      guests,
      filteredGuestItems,
      filteredSourceItems,
      filteredRoomItems,
      roomPrice,
      totalPriceBeforeDiscount,
      totalExtraChargePrice,
      grandTotal,
      discountAmount,
      calculateDays,
      searchQuery,
      isTyped,
      sourceTypes,
      modalResponse,
      formatIDR,
      isHighSeason,
    };
  },
};
</script>

<style>
@media screen and (max-width: 576px) {
  .modal-title .title {
    font-size: 1rem;
  }
  .modal-title .date,
  .modal-title .info-status {
    font-size: 0.675rem;
  }
}
</style>
